"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84, _85, _86, _87, _88, _89, _90, _91, _92;
Object.defineProperty(exports, "__esModule", { value: true });
exports.categories = exports.PRIORITY_KEY = void 0;
var PRIORITY_KEY;
(function (PRIORITY_KEY) {
    PRIORITY_KEY["ID"] = "idPriority";
    PRIORITY_KEY["MY"] = "myPriority";
    PRIORITY_KEY["TH"] = "thPriority";
})(PRIORITY_KEY = exports.PRIORITY_KEY || (exports.PRIORITY_KEY = {}));
exports.categories = {
    "1001": (_a = {
            name: "Bakery",
            i18nKey: "shop.category.bakery"
        },
        _a[PRIORITY_KEY.ID] = 0,
        _a[PRIORITY_KEY.MY] = 0,
        _a[PRIORITY_KEY.TH] = 18,
        _a),
    "1002": (_b = {
            name: "Pastries",
            i18nKey: "shop.category.pastries"
        },
        _b[PRIORITY_KEY.ID] = 0,
        _b[PRIORITY_KEY.MY] = 15,
        _b[PRIORITY_KEY.TH] = 0,
        _b),
    "1003": (_c = {
            name: "Cake",
            i18nKey: "shop.category.cake"
        },
        _c[PRIORITY_KEY.ID] = 33,
        _c[PRIORITY_KEY.MY] = 13,
        _c[PRIORITY_KEY.TH] = 17,
        _c),
    "1004": (_d = {
            name: "Cookies",
            i18nKey: "shop.category.cookies"
        },
        _d[PRIORITY_KEY.ID] = 51,
        _d[PRIORITY_KEY.MY] = 16,
        _d[PRIORITY_KEY.TH] = 16,
        _d),
    "1005": (_e = {
            name: "Bread",
            i18nKey: "shop.category.bread"
        },
        _e[PRIORITY_KEY.ID] = 20,
        _e[PRIORITY_KEY.MY] = 14,
        _e[PRIORITY_KEY.TH] = 0,
        _e),
    "2001": (_f = {
            name: "Juice & Smoothies",
            i18nKey: "shop.category.juice_smoothies"
        },
        _f[PRIORITY_KEY.ID] = 32,
        _f[PRIORITY_KEY.MY] = 7,
        _f[PRIORITY_KEY.TH] = 32,
        _f),
    "2002": (_g = {
            name: "Milk",
            i18nKey: "shop.category.milk"
        },
        _g[PRIORITY_KEY.ID] = 40,
        _g[PRIORITY_KEY.MY] = 0,
        _g[PRIORITY_KEY.TH] = 35,
        _g),
    "2003": (_h = {
            name: "Tea",
            i18nKey: "shop.category.tea"
        },
        _h[PRIORITY_KEY.ID] = 18,
        _h[PRIORITY_KEY.MY] = 8,
        _h[PRIORITY_KEY.TH] = 34,
        _h),
    "2004": (_j = {
            name: "Coffee",
            i18nKey: "shop.category.coffee"
        },
        _j[PRIORITY_KEY.ID] = 8,
        _j[PRIORITY_KEY.MY] = 6,
        _j[PRIORITY_KEY.TH] = 33,
        _j),
    "2005": (_k = {
            name: "Bubble Tea",
            i18nKey: "shop.category.bubble_tea"
        },
        _k[PRIORITY_KEY.ID] = 17,
        _k[PRIORITY_KEY.MY] = 5,
        _k[PRIORITY_KEY.TH] = 36,
        _k),
    "2006": (_l = {
            name: "Soft Drink",
            i18nKey: "shop.category.soft_drink"
        },
        _l[PRIORITY_KEY.ID] = 0,
        _l[PRIORITY_KEY.MY] = 0,
        _l[PRIORITY_KEY.TH] = 37,
        _l),
    "2007": (_m = {
            name: "Alcohol",
            i18nKey: "shop.category.alcohol"
        },
        _m[PRIORITY_KEY.ID] = 50,
        _m[PRIORITY_KEY.MY] = 0,
        _m[PRIORITY_KEY.TH] = 0,
        _m),
    "2008": (_o = {
            name: "Local Beverage",
            i18nKey: "shop.category.local_beverage"
        },
        _o[PRIORITY_KEY.ID] = 0,
        _o[PRIORITY_KEY.MY] = 9,
        _o[PRIORITY_KEY.TH] = 0,
        _o),
    "2009": (_p = {
            name: "Beverages",
            i18nKey: "shop.category.beverages"
        },
        _p[PRIORITY_KEY.ID] = 0,
        _p[PRIORITY_KEY.MY] = 0,
        _p[PRIORITY_KEY.TH] = 38,
        _p),
    "3001": (_q = {
            name: "Yogurt",
            i18nKey: "shop.category.yogurt"
        },
        _q[PRIORITY_KEY.ID] = 0,
        _q[PRIORITY_KEY.MY] = 22,
        _q[PRIORITY_KEY.TH] = 22,
        _q),
    "3002": (_r = {
            name: "Ice Cream",
            i18nKey: "shop.category.ice_cream"
        },
        _r[PRIORITY_KEY.ID] = 36,
        _r[PRIORITY_KEY.MY] = 21,
        _r[PRIORITY_KEY.TH] = 20,
        _r),
    "3003": (_s = {
            name: "Sweets",
            i18nKey: "shop.category.sweets"
        },
        _s[PRIORITY_KEY.ID] = 35,
        _s[PRIORITY_KEY.MY] = 20,
        _s[PRIORITY_KEY.TH] = 0,
        _s),
    "3004": (_t = {
            name: "Pancake",
            i18nKey: "shop.category.pancake"
        },
        _t[PRIORITY_KEY.ID] = 0,
        _t[PRIORITY_KEY.MY] = 0,
        _t[PRIORITY_KEY.TH] = 21,
        _t),
    "3005": (_u = {
            name: "Shaved Ice",
            i18nKey: "shop.category.shaved_ice"
        },
        _u[PRIORITY_KEY.ID] = 0,
        _u[PRIORITY_KEY.MY] = 18,
        _u[PRIORITY_KEY.TH] = 23,
        _u),
    "3006": (_v = {
            name: "Waffle",
            i18nKey: "shop.category.waffle"
        },
        _v[PRIORITY_KEY.ID] = 0,
        _v[PRIORITY_KEY.MY] = 0,
        _v[PRIORITY_KEY.TH] = 24,
        _v),
    "3007": (_w = {
            name: "Crepe",
            i18nKey: "shop.category.crepe"
        },
        _w[PRIORITY_KEY.ID] = 0,
        _w[PRIORITY_KEY.MY] = 0,
        _w[PRIORITY_KEY.TH] = 25,
        _w),
    "3008": (_x = {
            name: "Bingsu",
            i18nKey: "shop.category.bingsu"
        },
        _x[PRIORITY_KEY.ID] = 0,
        _x[PRIORITY_KEY.MY] = 0,
        _x[PRIORITY_KEY.TH] = 19,
        _x),
    "3009": (_y = {
            name: "Martabak",
            i18nKey: "shop.category.martabak"
        },
        _y[PRIORITY_KEY.ID] = 10,
        _y[PRIORITY_KEY.MY] = 0,
        _y[PRIORITY_KEY.TH] = 0,
        _y),
    "3010": (_z = {
            name: "Fruits",
            i18nKey: "shop.category.fruits"
        },
        _z[PRIORITY_KEY.ID] = 34,
        _z[PRIORITY_KEY.MY] = 0,
        _z[PRIORITY_KEY.TH] = 0,
        _z),
    "3011": (_0 = {
            name: "Dessert",
            i18nKey: "shop.category.dessert"
        },
        _0[PRIORITY_KEY.ID] = 0,
        _0[PRIORITY_KEY.MY] = 0,
        _0[PRIORITY_KEY.TH] = 26,
        _0),
    "3101": (_1 = {
            name: "Halal",
            i18nKey: "shop.category.halal"
        },
        _1[PRIORITY_KEY.ID] = 0,
        _1[PRIORITY_KEY.MY] = 0,
        _1[PRIORITY_KEY.TH] = 1,
        _1),
    "4001": (_2 = {
            name: "Meatball/Fishball",
            i18nKey: "shop.category.meatball_fishball"
        },
        _2[PRIORITY_KEY.ID] = 0,
        _2[PRIORITY_KEY.MY] = 0,
        _2[PRIORITY_KEY.TH] = 29,
        _2),
    "4002": (_3 = {
            name: "Soup",
            i18nKey: "shop.category.soup"
        },
        _3[PRIORITY_KEY.ID] = 0,
        _3[PRIORITY_KEY.MY] = 0,
        _3[PRIORITY_KEY.TH] = 28,
        _3),
    "4003": (_4 = {
            name: "Snack",
            i18nKey: "shop.category.snack"
        },
        _4[PRIORITY_KEY.ID] = 11,
        _4[PRIORITY_KEY.MY] = 17,
        _4[PRIORITY_KEY.TH] = 27,
        _4),
    "4004": (_5 = {
            name: "Fresh Fruits",
            i18nKey: "shop.category.fresh_fruits"
        },
        _5[PRIORITY_KEY.ID] = 0,
        _5[PRIORITY_KEY.MY] = 19,
        _5[PRIORITY_KEY.TH] = 30,
        _5),
    "4005": (_6 = {
            name: "Appetizer",
            i18nKey: "shop.category.appetizer"
        },
        _6[PRIORITY_KEY.ID] = 0,
        _6[PRIORITY_KEY.MY] = 0,
        _6[PRIORITY_KEY.TH] = 31,
        _6),
    "5001": (_7 = {
            name: "Poke Bowl",
            i18nKey: "shop.category.poke_bowl"
        },
        _7[PRIORITY_KEY.ID] = 0,
        _7[PRIORITY_KEY.MY] = 33,
        _7[PRIORITY_KEY.TH] = 0,
        _7),
    "5002": (_8 = {
            name: "Acai Bowl",
            i18nKey: "shop.category.acai_bowl"
        },
        _8[PRIORITY_KEY.ID] = 0,
        _8[PRIORITY_KEY.MY] = 0,
        _8[PRIORITY_KEY.TH] = 12,
        _8),
    "5003": (_9 = {
            name: "Organic",
            i18nKey: "shop.category.organic"
        },
        _9[PRIORITY_KEY.ID] = 0,
        _9[PRIORITY_KEY.MY] = 0,
        _9[PRIORITY_KEY.TH] = 13,
        _9),
    "5004": (_10 = {
            name: "Salad",
            i18nKey: "shop.category.salad"
        },
        _10[PRIORITY_KEY.ID] = 39,
        _10[PRIORITY_KEY.MY] = 34,
        _10[PRIORITY_KEY.TH] = 14,
        _10),
    "5005": (_11 = {
            name: "Konjac",
            i18nKey: "shop.category.konjac"
        },
        _11[PRIORITY_KEY.ID] = 60,
        _11[PRIORITY_KEY.MY] = 0,
        _11[PRIORITY_KEY.TH] = 0,
        _11),
    "5006": (_12 = {
            name: "Jamu & Herbal Drink",
            i18nKey: "shop.category.jamu_herbal_drink"
        },
        _12[PRIORITY_KEY.ID] = 59,
        _12[PRIORITY_KEY.MY] = 0,
        _12[PRIORITY_KEY.TH] = 0,
        _12),
    "5007": (_13 = {
            name: "Healthy",
            i18nKey: "shop.category.healthy"
        },
        _13[PRIORITY_KEY.ID] = 0,
        _13[PRIORITY_KEY.MY] = 0,
        _13[PRIORITY_KEY.TH] = 15,
        _13),
    "6001": (_14 = {
            name: "Vegetarian",
            i18nKey: "shop.category.vegetarian"
        },
        _14[PRIORITY_KEY.ID] = 61,
        _14[PRIORITY_KEY.MY] = 35,
        _14[PRIORITY_KEY.TH] = 11,
        _14),
    "6002": (_15 = {
            name: "Vegan",
            i18nKey: "shop.category.vegan"
        },
        _15[PRIORITY_KEY.ID] = 0,
        _15[PRIORITY_KEY.MY] = 36,
        _15[PRIORITY_KEY.TH] = 10,
        _15),
    "7001": (_16 = {
            name: "Pizza & Pasta",
            i18nKey: "shop.category.pizza_pasta"
        },
        _16[PRIORITY_KEY.ID] = 30,
        _16[PRIORITY_KEY.MY] = 4,
        _16[PRIORITY_KEY.TH] = 0,
        _16),
    "7002": (_17 = {
            name: "Burger",
            i18nKey: "shop.category.burger"
        },
        _17[PRIORITY_KEY.ID] = 31,
        _17[PRIORITY_KEY.MY] = 2,
        _17[PRIORITY_KEY.TH] = 2,
        _17),
    "7003": (_18 = {
            name: "Fried Chicken",
            i18nKey: "shop.category.fried_chicken"
        },
        _18[PRIORITY_KEY.ID] = 4,
        _18[PRIORITY_KEY.MY] = 1,
        _18[PRIORITY_KEY.TH] = 0,
        _18),
    "7004": (_19 = {
            name: "Sandwich & Wraps",
            i18nKey: "shop.category.sandwich _wraps"
        },
        _19[PRIORITY_KEY.ID] = 47,
        _19[PRIORITY_KEY.MY] = 3,
        _19[PRIORITY_KEY.TH] = 4,
        _19),
    "7005": (_20 = {
            name: "Hotdog",
            i18nKey: "shop.category.hotdog"
        },
        _20[PRIORITY_KEY.ID] = 54,
        _20[PRIORITY_KEY.MY] = 0,
        _20[PRIORITY_KEY.TH] = 0,
        _20),
    "7006": (_21 = {
            name: "Kebab",
            i18nKey: "shop.category.kebab"
        },
        _21[PRIORITY_KEY.ID] = 19,
        _21[PRIORITY_KEY.MY] = 0,
        _21[PRIORITY_KEY.TH] = 5,
        _21),
    "7007": (_22 = {
            name: "Fast Food",
            i18nKey: "shop.category.fast_food"
        },
        _22[PRIORITY_KEY.ID] = 0,
        _22[PRIORITY_KEY.MY] = 0,
        _22[PRIORITY_KEY.TH] = 6,
        _22),
    "7008": (_23 = {
            name: "Fried Food",
            i18nKey: "shop.category.fried_food"
        },
        _23[PRIORITY_KEY.ID] = 22,
        _23[PRIORITY_KEY.MY] = 0,
        _23[PRIORITY_KEY.TH] = 2,
        _23),
    "8001": (_24 = {
            name: "Beef",
            i18nKey: "shop.category.beef"
        },
        _24[PRIORITY_KEY.ID] = 26,
        _24[PRIORITY_KEY.MY] = 0,
        _24[PRIORITY_KEY.TH] = 0,
        _24),
    "8002": (_25 = {
            name: "Chicken",
            i18nKey: "shop.category.chicken"
        },
        _25[PRIORITY_KEY.ID] = 2,
        _25[PRIORITY_KEY.MY] = 0,
        _25[PRIORITY_KEY.TH] = 0,
        _25),
    "8003": (_26 = {
            name: "Pork",
            i18nKey: "shop.category.pork"
        },
        _26[PRIORITY_KEY.ID] = 43,
        _26[PRIORITY_KEY.MY] = 0,
        _26[PRIORITY_KEY.TH] = 0,
        _26),
    "8004": (_27 = {
            name: "Duck",
            i18nKey: "shop.category.duck"
        },
        _27[PRIORITY_KEY.ID] = 28,
        _27[PRIORITY_KEY.MY] = 0,
        _27[PRIORITY_KEY.TH] = 0,
        _27),
    "8005": (_28 = {
            name: "Satay",
            i18nKey: "shop.category.satay"
        },
        _28[PRIORITY_KEY.ID] = 14,
        _28[PRIORITY_KEY.MY] = 0,
        _28[PRIORITY_KEY.TH] = 0,
        _28),
    "8006": (_29 = {
            name: "Meatball & Soto",
            i18nKey: "shop.category.meatball_soto"
        },
        _29[PRIORITY_KEY.ID] = 15,
        _29[PRIORITY_KEY.MY] = 0,
        _29[PRIORITY_KEY.TH] = 0,
        _29),
    "8007": (_30 = {
            name: "Lamb",
            i18nKey: "shop.category.lamb"
        },
        _30[PRIORITY_KEY.ID] = 0,
        _30[PRIORITY_KEY.MY] = 0,
        _30[PRIORITY_KEY.TH] = 0,
        _30),
    "9001": (_31 = {
            name: "Seafood",
            i18nKey: "shop.category.seafood"
        },
        _31[PRIORITY_KEY.ID] = 21,
        _31[PRIORITY_KEY.MY] = 37,
        _31[PRIORITY_KEY.TH] = 79,
        _31),
    "1101": (_32 = {
            name: "Noodles",
            i18nKey: "shop.category.noodles"
        },
        _32[PRIORITY_KEY.ID] = 0,
        _32[PRIORITY_KEY.MY] = 12,
        _32[PRIORITY_KEY.TH] = 9,
        _32),
    "1102": (_33 = {
            name: "Fried Noodles",
            i18nKey: "shop.category.fried_noodles"
        },
        _33[PRIORITY_KEY.ID] = 9,
        _33[PRIORITY_KEY.MY] = 0,
        _33[PRIORITY_KEY.TH] = 7,
        _33),
    "1103": (_34 = {
            name: "Noodle Soup",
            i18nKey: "shop.category.noodle_soup"
        },
        _34[PRIORITY_KEY.ID] = 48,
        _34[PRIORITY_KEY.MY] = 0,
        _34[PRIORITY_KEY.TH] = 8,
        _34),
    "1104": (_35 = {
            name: "Chicken Noodles",
            i18nKey: "shop.category.chicken_noodles"
        },
        _35[PRIORITY_KEY.ID] = 23,
        _35[PRIORITY_KEY.MY] = 0,
        _35[PRIORITY_KEY.TH] = 0,
        _35),
    "1105": (_36 = {
            name: "Bakmi",
            i18nKey: "shop.category.bakmi"
        },
        _36[PRIORITY_KEY.ID] = 5,
        _36[PRIORITY_KEY.MY] = 0,
        _36[PRIORITY_KEY.TH] = 0,
        _36),
    "1201": (_37 = {
            name: "Rice",
            i18nKey: "shop.category.rice"
        },
        _37[PRIORITY_KEY.ID] = 3,
        _37[PRIORITY_KEY.MY] = 10,
        _37[PRIORITY_KEY.TH] = 0,
        _37),
    "1202": (_38 = {
            name: "Chicken Rice",
            i18nKey: "shop.category.chicken_rice"
        },
        _38[PRIORITY_KEY.ID] = 1,
        _38[PRIORITY_KEY.MY] = 0,
        _38[PRIORITY_KEY.TH] = 0,
        _38),
    "1203": (_39 = {
            name: "Porridge",
            i18nKey: "shop.category.porridge"
        },
        _39[PRIORITY_KEY.ID] = 27,
        _39[PRIORITY_KEY.MY] = 11,
        _39[PRIORITY_KEY.TH] = 0,
        _39),
    "1204": (_40 = {
            name: "Fried Rice",
            i18nKey: "shop.category.fried_rice"
        },
        _40[PRIORITY_KEY.ID] = 6,
        _40[PRIORITY_KEY.MY] = 0,
        _40[PRIORITY_KEY.TH] = 0,
        _40),
    "1205": (_41 = {
            name: "Grilled Rice",
            i18nKey: "shop.category.grilled_rice"
        },
        _41[PRIORITY_KEY.ID] = 41,
        _41[PRIORITY_KEY.MY] = 0,
        _41[PRIORITY_KEY.TH] = 0,
        _41),
    "1206": (_42 = {
            name: "Rice Bowl",
            i18nKey: "shop.category.rice_bowl"
        },
        _42[PRIORITY_KEY.ID] = 29,
        _42[PRIORITY_KEY.MY] = 0,
        _42[PRIORITY_KEY.TH] = 0,
        _42),
    "1301": (_43 = {
            name: "Japanese",
            i18nKey: "shop.category.japanese"
        },
        _43[PRIORITY_KEY.ID] = 12,
        _43[PRIORITY_KEY.MY] = 28,
        _43[PRIORITY_KEY.TH] = 69,
        _43),
    "1302": (_44 = {
            name: "BBQ/Yakiniku",
            i18nKey: "shop.category.bbq_yakiniku"
        },
        _44[PRIORITY_KEY.ID] = 0,
        _44[PRIORITY_KEY.MY] = 0,
        _44[PRIORITY_KEY.TH] = 61,
        _44),
    "1303": (_45 = {
            name: "Ramen",
            i18nKey: "shop.category.ramen"
        },
        _45[PRIORITY_KEY.ID] = 0,
        _45[PRIORITY_KEY.MY] = 0,
        _45[PRIORITY_KEY.TH] = 66,
        _45),
    "1304": (_46 = {
            name: "Sukiyaki/Shabu",
            i18nKey: "shop.category.sukiyaki_shabu"
        },
        _46[PRIORITY_KEY.ID] = 0,
        _46[PRIORITY_KEY.MY] = 0,
        _46[PRIORITY_KEY.TH] = 67,
        _46),
    "1305": (_47 = {
            name: "Sushi",
            i18nKey: "shop.category.sushi"
        },
        _47[PRIORITY_KEY.ID] = 0,
        _47[PRIORITY_KEY.MY] = 0,
        _47[PRIORITY_KEY.TH] = 68,
        _47),
    "1306": (_48 = {
            name: "Izakaya",
            i18nKey: "shop.category.izakaya"
        },
        _48[PRIORITY_KEY.ID] = 0,
        _48[PRIORITY_KEY.MY] = 0,
        _48[PRIORITY_KEY.TH] = 65,
        _48),
    "1307": (_49 = {
            name: "Donburi",
            i18nKey: "shop.category.donburi"
        },
        _49[PRIORITY_KEY.ID] = 0,
        _49[PRIORITY_KEY.MY] = 0,
        _49[PRIORITY_KEY.TH] = 63,
        _49),
    "1308": (_50 = {
            name: "Curry Rice",
            i18nKey: "shop.category.curry_rice"
        },
        _50[PRIORITY_KEY.ID] = 0,
        _50[PRIORITY_KEY.MY] = 0,
        _50[PRIORITY_KEY.TH] = 62,
        _50),
    "1309": (_51 = {
            name: "Gyoza",
            i18nKey: "shop.category.gyoza"
        },
        _51[PRIORITY_KEY.ID] = 0,
        _51[PRIORITY_KEY.MY] = 0,
        _51[PRIORITY_KEY.TH] = 64,
        _51),
    "1401": (_52 = {
            name: "Chinese",
            i18nKey: "shop.category.chinese"
        },
        _52[PRIORITY_KEY.ID] = 25,
        _52[PRIORITY_KEY.MY] = 23,
        _52[PRIORITY_KEY.TH] = 43,
        _52),
    "1402": (_53 = {
            name: "Mala",
            i18nKey: "shop.category.mala"
        },
        _53[PRIORITY_KEY.ID] = 0,
        _53[PRIORITY_KEY.MY] = 0,
        _53[PRIORITY_KEY.TH] = 42,
        _53),
    "1403": (_54 = {
            name: "Dimsum",
            i18nKey: "shop.category.dimsum"
        },
        _54[PRIORITY_KEY.ID] = 0,
        _54[PRIORITY_KEY.MY] = 0,
        _54[PRIORITY_KEY.TH] = 41,
        _54),
    "1404": (_55 = {
            name: "Chinese Hotpot",
            i18nKey: "shop.category.chinese_hotpot"
        },
        _55[PRIORITY_KEY.ID] = 0,
        _55[PRIORITY_KEY.MY] = 0,
        _55[PRIORITY_KEY.TH] = 40,
        _55),
    "1405": (_56 = {
            name: "Chinese Congee",
            i18nKey: "shop.category.chinese_congee"
        },
        _56[PRIORITY_KEY.ID] = 0,
        _56[PRIORITY_KEY.MY] = 0,
        _56[PRIORITY_KEY.TH] = 39,
        _56),
    "1501": (_57 = {
            name: "Korean",
            i18nKey: "shop.category.korean"
        },
        _57[PRIORITY_KEY.ID] = 24,
        _57[PRIORITY_KEY.MY] = 27,
        _57[PRIORITY_KEY.TH] = 72,
        _57),
    "1601": (_58 = {
            name: "Italian",
            i18nKey: "shop.category.italian"
        },
        _58[PRIORITY_KEY.ID] = 55,
        _58[PRIORITY_KEY.MY] = 0,
        _58[PRIORITY_KEY.TH] = 71,
        _58),
    "1701": (_59 = {
            name: "Middle-East",
            i18nKey: "shop.category.middle_east"
        },
        _59[PRIORITY_KEY.ID] = 42,
        _59[PRIORITY_KEY.MY] = 30,
        _59[PRIORITY_KEY.TH] = 74,
        _59),
    "1801": (_60 = {
            name: "International",
            i18nKey: "shop.category.international"
        },
        _60[PRIORITY_KEY.ID] = 0,
        _60[PRIORITY_KEY.MY] = 0,
        _60[PRIORITY_KEY.TH] = 77,
        _60),
    "1901": (_61 = {
            name: "Western",
            i18nKey: "shop.category.western"
        },
        _61[PRIORITY_KEY.ID] = 38,
        _61[PRIORITY_KEY.MY] = 29,
        _61[PRIORITY_KEY.TH] = 60,
        _61),
    "1902": (_62 = {
            name: "Steak",
            i18nKey: "shop.category.steak"
        },
        _62[PRIORITY_KEY.ID] = 0,
        _62[PRIORITY_KEY.MY] = 0,
        _62[PRIORITY_KEY.TH] = 57,
        _62),
    "1903": (_63 = {
            name: "Cold Cuts & Platter",
            i18nKey: "shop.category.cold_cuts_platter"
        },
        _63[PRIORITY_KEY.ID] = 0,
        _63[PRIORITY_KEY.MY] = 0,
        _63[PRIORITY_KEY.TH] = 59,
        _63),
    "1904": (_64 = {
            name: "Tapas",
            i18nKey: "shop.category.tapas"
        },
        _64[PRIORITY_KEY.ID] = 0,
        _64[PRIORITY_KEY.MY] = 0,
        _64[PRIORITY_KEY.TH] = 58,
        _64),
    "1905": (_65 = {
            name: "Pizza",
            i18nKey: "shop.category.pizza"
        },
        _65[PRIORITY_KEY.ID] = 0,
        _65[PRIORITY_KEY.MY] = 0,
        _65[PRIORITY_KEY.TH] = 56,
        _65),
    "1906": (_66 = {
            name: "Pasta",
            i18nKey: "shop.category.pasta"
        },
        _66[PRIORITY_KEY.ID] = 0,
        _66[PRIORITY_KEY.MY] = 0,
        _66[PRIORITY_KEY.TH] = 55,
        _66),
    "2101": (_67 = {
            name: "Thai",
            i18nKey: "shop.category.thai"
        },
        _67[PRIORITY_KEY.ID] = 52,
        _67[PRIORITY_KEY.MY] = 32,
        _67[PRIORITY_KEY.TH] = 54,
        _67),
    "2102": (_68 = {
            name: "Somtum",
            i18nKey: "shop.category.somtum"
        },
        _68[PRIORITY_KEY.ID] = 0,
        _68[PRIORITY_KEY.MY] = 0,
        _68[PRIORITY_KEY.TH] = 46,
        _68),
    "2103": (_69 = {
            name: "Street Food",
            i18nKey: "shop.category.street_food"
        },
        _69[PRIORITY_KEY.ID] = 0,
        _69[PRIORITY_KEY.MY] = 0,
        _69[PRIORITY_KEY.TH] = 47,
        _69),
    "2104": (_70 = {
            name: "Cooked to Order",
            i18nKey: "shop.category.cooked_to_order"
        },
        _70[PRIORITY_KEY.ID] = 0,
        _70[PRIORITY_KEY.MY] = 0,
        _70[PRIORITY_KEY.TH] = 45,
        _70),
    "2105": (_71 = {
            name: "Yum",
            i18nKey: "shop.category.yum"
        },
        _71[PRIORITY_KEY.ID] = 0,
        _71[PRIORITY_KEY.MY] = 0,
        _71[PRIORITY_KEY.TH] = 50,
        _71),
    "2106": (_72 = {
            name: "Esan",
            i18nKey: "shop.category.esan"
        },
        _72[PRIORITY_KEY.ID] = 0,
        _72[PRIORITY_KEY.MY] = 0,
        _72[PRIORITY_KEY.TH] = 51,
        _72),
    "2107": (_73 = {
            name: "Southern",
            i18nKey: "shop.category.southern"
        },
        _73[PRIORITY_KEY.ID] = 0,
        _73[PRIORITY_KEY.MY] = 0,
        _73[PRIORITY_KEY.TH] = 53,
        _73),
    "2108": (_74 = {
            name: "Northern",
            i18nKey: "shop.category.northern"
        },
        _74[PRIORITY_KEY.ID] = 0,
        _74[PRIORITY_KEY.MY] = 0,
        _74[PRIORITY_KEY.TH] = 52,
        _74),
    "2109": (_75 = {
            name: "Thai Congee",
            i18nKey: "shop.category.thai_congee"
        },
        _75[PRIORITY_KEY.ID] = 0,
        _75[PRIORITY_KEY.MY] = 0,
        _75[PRIORITY_KEY.TH] = 44,
        _75),
    "2110": (_76 = {
            name: "Thai Hotpot",
            i18nKey: "shop.category.thai_hotpot"
        },
        _76[PRIORITY_KEY.ID] = 0,
        _76[PRIORITY_KEY.MY] = 0,
        _76[PRIORITY_KEY.TH] = 48,
        _76),
    "2111": (_77 = {
            name: "Thai Curry",
            i18nKey: "shop.category.thai_curry"
        },
        _77[PRIORITY_KEY.ID] = 0,
        _77[PRIORITY_KEY.MY] = 0,
        _77[PRIORITY_KEY.TH] = 49,
        _77),
    "2201": (_78 = {
            name: "Malaysian",
            i18nKey: "shop.category.malaysian"
        },
        _78[PRIORITY_KEY.ID] = 0,
        _78[PRIORITY_KEY.MY] = 25,
        _78[PRIORITY_KEY.TH] = 0,
        _78),
    "2202": (_79 = {
            name: "Satay",
            i18nKey: "shop.category.satay"
        },
        _79[PRIORITY_KEY.ID] = 14,
        _79[PRIORITY_KEY.MY] = 26,
        _79[PRIORITY_KEY.TH] = 0,
        _79),
    "2301": (_80 = {
            name: "Indian",
            i18nKey: "shop.category.indian"
        },
        _80[PRIORITY_KEY.ID] = 53,
        _80[PRIORITY_KEY.MY] = 24,
        _80[PRIORITY_KEY.TH] = 70,
        _80),
    "2401": (_81 = {
            name: "Vietnamese",
            i18nKey: "shop.category.vietnamese"
        },
        _81[PRIORITY_KEY.ID] = 58,
        _81[PRIORITY_KEY.MY] = 31,
        _81[PRIORITY_KEY.TH] = 75,
        _81),
    "2501": (_82 = {
            name: "Mexican",
            i18nKey: "shop.category.mexican"
        },
        _82[PRIORITY_KEY.ID] = 0,
        _82[PRIORITY_KEY.MY] = 0,
        _82[PRIORITY_KEY.TH] = 73,
        _82),
    "2601": (_83 = {
            name: "Convenient Store",
            i18nKey: "shop.category.convenient_store"
        },
        _83[PRIORITY_KEY.ID] = 37,
        _83[PRIORITY_KEY.MY] = 38,
        _83[PRIORITY_KEY.TH] = 0,
        _83),
    "2701": (_84 = {
            name: "Fusion",
            i18nKey: "shop.category.fusion"
        },
        _84[PRIORITY_KEY.ID] = 0,
        _84[PRIORITY_KEY.MY] = 0,
        _84[PRIORITY_KEY.TH] = 76,
        _84),
    "2801": (_85 = {
            name: "Fine Dining",
            i18nKey: "shop.category.fine_dining"
        },
        _85[PRIORITY_KEY.ID] = 0,
        _85[PRIORITY_KEY.MY] = 0,
        _85[PRIORITY_KEY.TH] = 78,
        _85),
    "2901": (_86 = {
            name: "Padang",
            i18nKey: "shop.category.padang"
        },
        _86[PRIORITY_KEY.ID] = 7,
        _86[PRIORITY_KEY.MY] = 0,
        _86[PRIORITY_KEY.TH] = 0,
        _86),
    "2902": (_87 = {
            name: "Manado",
            i18nKey: "shop.category.manado"
        },
        _87[PRIORITY_KEY.ID] = 49,
        _87[PRIORITY_KEY.MY] = 0,
        _87[PRIORITY_KEY.TH] = 0,
        _87),
    "2903": (_88 = {
            name: "Jawa",
            i18nKey: "shop.category.jawa"
        },
        _88[PRIORITY_KEY.ID] = 16,
        _88[PRIORITY_KEY.MY] = 0,
        _88[PRIORITY_KEY.TH] = 0,
        _88),
    "2904": (_89 = {
            name: "Sunda",
            i18nKey: "shop.category.sunda"
        },
        _89[PRIORITY_KEY.ID] = 13,
        _89[PRIORITY_KEY.MY] = 0,
        _89[PRIORITY_KEY.TH] = 0,
        _89),
    "2905": (_90 = {
            name: "Bali",
            i18nKey: "shop.category.bali"
        },
        _90[PRIORITY_KEY.ID] = 45,
        _90[PRIORITY_KEY.MY] = 0,
        _90[PRIORITY_KEY.TH] = 0,
        _90),
    "2906": (_91 = {
            name: "Aceh",
            i18nKey: "shop.category.aceh"
        },
        _91[PRIORITY_KEY.ID] = 44,
        _91[PRIORITY_KEY.MY] = 0,
        _91[PRIORITY_KEY.TH] = 0,
        _91),
    "2907": (_92 = {
            name: "Medan",
            i18nKey: "shop.category.medan"
        },
        _92[PRIORITY_KEY.ID] = 46,
        _92[PRIORITY_KEY.MY] = 0,
        _92[PRIORITY_KEY.TH] = 0,
        _92),
};
